import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { StorageKey } from "../../../../App/enums"
import { selectTranslations } from "../../../../App/i18n/i18nSlice"
import StorageService from "../../../../App/StorageService"
import { RootState } from "../../../../App/store"
import "../../../../Styles/main.scss"
import EditDescriptionModal from "../../../Shared/Components/EditDescriptionModal"
import { setModalData } from "../../../Shared/SharedSlices/ModalSlice"
import { patchUserDescription } from "./UserProfileDescriptionEditServiceRequest"

function UserProfileDescriptionEditDescription() {
    const userDataState = useSelector((state: RootState) => state.userDataSlice)
    const translation = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const [description, setDescription] = useState(userDataState.description)

    const onModalClose = () => {
        dispatch(setModalData({ open: false, editDescription: false }))
    }

    useEffect(() => {
        if (userDataState.id) {
            let stringUser = StorageService.stringify(userDataState)
            StorageService.setItem(StorageKey.user, stringUser)
        }
    }, [description.length, userDataState])

    const onFormSubmit = (event: { preventDefault: () => void }) => {
        event.preventDefault()
        dispatch<any>(patchUserDescription(description, userDataState))
        onModalClose()
    }

    return (
        <EditDescriptionModal
            closeModal={onModalClose}
            title={translation.myRoleinEducation}
            description={description}
            setDescription={setDescription}
            onSubmit={onFormSubmit}
        />
    )
}

export default UserProfileDescriptionEditDescription
